export default __webpack_public_path__ + "static/benson-d5d308bf03413cfbc2abb0eff081f632.jpg";